<h1 mat-dialog-title>Notiță</h1>
<div mat-dialog-content fxLayout="column" fxLayoutGap="10px" >
    <div class="form-group" fxFlex="auto">
        <label class="label" for="adminNote">Notiță</label>
        <textarea nbInput [(ngModel)]="data.adminNote" placeholder="Notiță" id="adminNote" name="adminNote"></textarea>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Anulează</button>
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Salvează</button>
</div>
